<label>
    <ng-content select="[climbCheckbox]"></ng-content>
    <svg focusable="false" viewBox="0 0 16 16" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="checked" d="m5 8 2 2 4-4" stroke-linecap="square"/>
        <path class="indeterminate" d="M4.5 8h7"/>
    </svg>
    <span><ng-content></ng-content></span>
</label>
<ng-content select="[climbCheckboxHint], [climbCheckboxError]"></ng-content>
